import { trustedRequest } from 'utils/request';

export const getNews = (page: number = 0, size: number = 6) => trustedRequest(`/api/news?page=${page}&size=${size}`);
